const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const fmtInt = (n: number) => Math.round(n).toLocaleString('en-IN');
export const fmtG = (n: number) => { const r = Math.round(n * 10) / 10; return Math.abs(r) >= 10 || r % 1 === 0 ? String(Math.round(r)) : r.toFixed(1); };
export const fmtDate = (iso: string) => { const p = (iso || '').split('-'); return p.length === 3 ? `${+p[2]} ${MON[+p[1] - 1]} ${p[0]}` : iso; };
const pad2 = (n: number) => String(n).padStart(2, '0');
const parseIsoDay = (iso: string) => {
  const [y, m, d] = (iso || '').split('-').map(Number);
  return y && m && d ? new Date(y, m - 1, d) : null;
};
export const toIsoDate = (d: Date) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
export const daysBetween = (a: string, b: string) => {
  const da = parseIsoDay(a);
  const db = parseIsoDay(b);
  if (!da || !db) return 0;
  return Math.round((db.getTime() - da.getTime()) / 864e5);
};
export const hasValidDateRange = (from: string, to: string) => daysBetween(from, to) > 0;
export const initials = (name: string) => name.split(' ').filter(Boolean).slice(0, 2).map(s => s[0]).join('').toUpperCase();
export const firstName = (name: string) => name.split(' ')[0];
export const todayIso = () => toIsoDate(new Date());
export const plusDaysIso = (iso: string, d: number) => {
  const dt = parseIsoDay(iso);
  if (!dt) return iso;
  dt.setDate(dt.getDate() + d);
  return toIsoDate(dt);
};
export const inkFor = (hex: string) => { const n = parseInt(hex.slice(1), 16); const l = (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255; return l > 0.62 ? '#1D4D38' : '#FFFFFF'; };
